import getCharacteristicPrefixes from './getCharacteristicPrefixes'
//---------------------------------------
// save current editable characteristics
//---------------------------------------
export default function saveCurrentEditableCharacteristics(obj) {
  // -------------------
  // define empty array
  // -------------------
  let original_chars = {}
  // -----------------------------
  // get characteristic prefixes
  // -----------------------------
  const chars = getCharacteristicPrefixes()
  // -----------
  // loop chars
  // -----------
  chars.forEach((c) => {
    let char_rolled = c + '_rolled'
    let char_improvs_tot = c + '_improvs_tot'
    // ---------------------------------------
    // saves current editable characteristics
    // ---------------------------------------
    original_chars[char_rolled] = obj[char_rolled]
    original_chars[char_improvs_tot] = obj[char_improvs_tot]
  })
  return original_chars
}
